import React from 'react';
import { Container, ContainerProps } from '@mantine/core';

interface PageContainerProps extends Omit<ContainerProps, 'py' | 'px'> {
  children: React.ReactNode;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, ...props }) => {
  return (
    <Container
      size="xl"
      py={{ base: 0, sm: 'md' }}
      px={{ base: 0, sm: 'md' }}
      mb={{ base: 'md', sm: 0 }}
      {...props}
    >
      {children}
    </Container>
  );
};
